function getLibrary(apiClient, locale) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}`;
  return apiClient.get(route, { query: { locale } });
}

export default { getLibrary };



// WEBPACK FOOTER //
// ./app/api/LibraryApi.js